/**
 * SSO pro Virtus Site Builder (criação de landing pages com IA).
 *
 * O Site Builder ainda não aceita a sessão do SMM: por ora a URL só abre a aplicação. Já repassa o
 * access_token em `sso_token` no mesmo formato do Lead B2B (/auth/callback?sso_token=), para que o
 * login automático funcione assim que o Site Builder implementar essa rota.
 */
const SITE_BUILDER_BASE_URL = (
  (import.meta.env.VITE_SITE_BUILDER_URL as string | undefined) ||
  "https://sites.virtusautomation.com"
).replace(/\/$/, "");

/** URL de entrada com SSO (ou a home, sem sessão no SMM). Usada também pela rota /launch. */
export function getSiteBuilderSsoUrl(): string {
  const token = localStorage.getItem("access_token");
  if (!token) return SITE_BUILDER_BASE_URL;
  return `${SITE_BUILDER_BASE_URL}/auth/callback?sso_token=${encodeURIComponent(token)}`;
}

export function openSiteBuilderSSO(): void {
  window.open(getSiteBuilderSsoUrl(), "_blank", "noopener,noreferrer");
}
